import React from "react";
import "./style.css";
import churchIcon from "./church.png";

const events = [
  {
    time: "17:00",
    label: "Ceremonia",
    venue: "Parroquia San Juan Pablo II",
    address: "P.º de la Reina 2, Villa California, 45640 San Agustín, Jal.",
    icon: churchIcon,
    iconAlt: "iglesia",
    mapUrl: "https://maps.app.goo.gl/2Qsx9tffb5j3ukwSA",
    aosAnim: "fade-right",
  },
  {
    time: "19:30",
    label: "Ceremonia Civil",
    venue: "Bosque By Alofa",
    address: "Av. Adolfo López Mateos Sur 8009, 45645 Tlajomulco de Zúñiga, Jal.",
    icon: "https://img.icons8.com/dotty/80/000000/wedding-rings.png",
    iconAlt: "argollas",
    mapUrl: "https://maps.app.goo.gl/qf4AZwSxgadM2VnC9",
    aosAnim: "fade-up",
  },
  {
    time: "20:30",
    label: "Recepción",
    venue: "Bosque By Alofa",
    address: "Av. Adolfo López Mateos Sur 8009, 45645 Tlajomulco de Zúñiga, Jal.",
    icon: "https://img.icons8.com/dotty/80/000000/chandelier.png",
    iconAlt: "recepción",
    mapUrl: "https://maps.app.goo.gl/qf4AZwSxgadM2VnC9",
    aosAnim: "fade-left",
  },
];

const Itinerario = () => {
  return (
    <section id="schedule">

      <div className="itin-header" data-aos="fade-up">
        <h2 className="itin-title">Itinerario</h2>
        <div className="itin-rule"></div>
        <p className="itin-date">19 · Septiembre · 2026</p>
      </div>

      <div className="itin-cards">
        {events.map((ev, i) => (
          <React.Fragment key={ev.label}>
            <div className="itin-card" data-aos={ev.aosAnim} data-aos-delay={i * 100}>
              <p className="itin-time">{ev.time}</p>
              <div className="itin-time-rule"></div>
              <img className="itin-icon sink-on-hover" src={ev.icon} alt={ev.iconAlt} />
              <h3 className="itin-label">{ev.label}</h3>
              <p className="itin-venue">{ev.venue}</p>
              <p className="itin-address">{ev.address}</p>
              <a
                className="itin-map-btn shrink-on-hover-button"
                href={ev.mapUrl}
                target="_blank"
                rel="noreferrer"
                role="button"
              >
                Ver Mapa
              </a>
            </div>
            {i < events.length - 1 && <div className="itin-separator" />}
          </React.Fragment>
        ))}
      </div>

    </section>
  );
};

export default Itinerario;
